import { LangKey } from "@vixi/localization";
import { FlowStepper } from "@vixi/ui";
import { FC } from "react";

interface LinkedInStepperProps {
  activeStep: number;
}

const steps: LangKey[] = [
  "CreateCourseStepper.UploadEbook",
  "CreateCourseStepper.CourseGeneration",
  "CreateCourseStepper.CreateCharacter",
  "CreateCourseStepper.Review",
  "CreateCourseStepper.CourseCreated",
];

export const EbookStepper: FC<LinkedInStepperProps> = ({ activeStep }) => {
  return <FlowStepper activeStep={activeStep} steps={steps} />;
};
